module.exports = __webpack_public_path__ + "static/media/logoHPC.46362f38.png";